import { ResponsivePieCanvas } from "@nivo/pie";
import { pieChartData } from "../home.constants";
import UiContainer from "@/UI/Containers/UiContainer";

function PerformanceChart() {
  return (
    <UiContainer className="h-full rounded-lg border border-extraLightGray p-2">
      <h3 className="font-semibold">Performance Status</h3>
      <section className="h-full flex items-center gap-3">
        <div className="flex-1 h-full">
          <ResponsivePieCanvas
            data={pieChartData}
            margin={{ top: 20, bottom: 20, left: 10, right: 10 }}
            innerRadius={0.5}
            padAngle={0.7}
            startAngle={90}
            endAngle={-90}
            cornerRadius={3}
            activeOuterRadiusOffset={8}
            enableArcLinkLabels={false}
            colors={pieChartData.map((data) => data.color)}
            borderWidth={2}
            borderColor={{ theme: "background" }}
          />
        </div>
        <section className="flex flex-col gap-2">
          {pieChartData.map((data) => (
            <div key={data.id} className="flex items-center w-full gap-2">
              <div
                className="w-4 h-4 rounded-sm"
                style={{ backgroundColor: data.color }}
              />
              <p className="text-sm font-medium">{data.id}</p>
            </div>
          ))}
        </section>
      </section>
    </UiContainer>
  );
}

export default PerformanceChart;
